<template>
  <div class="sgs-report">
    <div class="sgs-header">
      <button class="sgs-back-btn" @click="goBack">&#8592; 返回</button>
      <h1 class="sgs-title">SGS 檢驗報告</h1>
      <p class="sgs-product-name">{{ productName }}</p>
    </div>

    <div class="sgs-pages">
      <img
        v-for="(img, idx) in images"
        :key="idx"
        :src="img"
        :alt="`${productName} SGS 檢驗報告 第 ${idx + 1} 頁`"
        class="sgs-page-img"
        loading="lazy"
      />
    </div>

    <div class="sgs-footer">
      <p>※ 以上報告由 SGS 台灣檢驗科技股份有限公司出具</p>
      <button class="sgs-back-btn2" @click="goBack">返回官網</button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const product = computed(() => route.params.product)

const productMap = {
  ampoule: {
    name: '璀璨之秘 外泌體安瓶',
    files: [
      'SGS_page_51.png','SGS_page_52.png','SGS_page_53.png','SGS_page_54.png',
      'SGS_page_55.png','SGS_page_56.png','SGS_page_57.png','SGS_page_58.png',
      'SGS_page_59.png','SGS_page_60.png',
    ],
  },
  mask: {
    name: '璀璨之秘 外泌體面膜',
    files: [
      'SGS_page_65.png','SGS_page_66.png','SGS_page_67.png','SGS_page_68.png',
      'SGS_page_69.png','SGS_page_70.png','SGS_page_71.png','SGS_page_75.png',
    ],
  },
  mousse: {
    name: '璀璨之秘 潔顏慕斯',
    files: [
      'SGS_page_51.png','SGS_page_52.png','SGS_page_53.png','SGS_page_54.png',
      'SGS_page_55.png','SGS_page_56.png','SGS_page_57.png',
    ],
  },
}

const productName = computed(() => productMap[product.value]?.name || 'SGS 檢驗報告')

function goBack() {
  if (window.history.length > 1) {
    window.history.back()
  } else {
    window.location.href = '/'
  }
}

const images = computed(() => {
  const info = productMap[product.value]
  if (!info) return []
  return info.files.map(f => `/sgs/${product.value}/${f}`)
})
</script>

<style scoped>
.sgs-report {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 40px;
}

.sgs-header {
  background: #fff;
  text-align: center;
  padding: 24px 16px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  position: relative;
}

.sgs-back-btn {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: 1px solid #c8a96e;
  color: #c8a96e;
  padding: 6px 14px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
}

.sgs-back-btn:hover {
  background: #c8a96e;
  color: #fff;
}

.sgs-title {
  font-size: 1.3rem;
  color: #4a3728;
  margin: 0 0 6px;
}

.sgs-product-name {
  font-size: 1rem;
  color: #8b7355;
  margin: 0;
}

.sgs-pages {
  max-width: 900px;
  margin: 24px auto;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sgs-page-img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  background: #fff;
}

.sgs-footer {
  text-align: center;
  padding: 20px 16px;
  color: #aaa;
  font-size: 0.85rem;
}

.sgs-back-btn2 {
  margin-top: 12px;
  background: #c8a96e;
  color: #fff;
  border: none;
  padding: 10px 28px;
  border-radius: 24px;
  cursor: pointer;
  font-size: 0.95rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.sgs-back-btn2:hover {
  background: #a8883e;
}

@media (max-width: 600px) {
  .sgs-back-btn {
    position: static;
    transform: none;
    display: block;
    margin: 0 auto 12px;
    width: fit-content;
  }
}
</style>
